import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
/**
 * 基础路由
 * @type { *[] }
 */
import store from '../store';
var constantRouterMap = null;
if (window.location.href.split('?')[1]) {
  var arr = window.location.href.split('?')[1].split('&');
  localStorage.setItem('parameter', window.location.href.split('?')[1]);
  var obj = {};
  arr.forEach(function (item, index) {
    var arr1 = item.split('=');
    obj[arr1[0]] = arr1[1];
  });
  store.state.nickname = obj.nickname;
  localStorage.setItem('nickname', obj.nickname);
  // store.state.avatar = obj.avatar
  store.state.userId = obj.uid;
  localStorage.setItem('uid', obj.uid);
  store.state.isOwner = obj.isOwner;
  localStorage.setItem('isOwner', obj.isOwner);
  store.state.language = obj.language;
  localStorage.setItem('language', obj.language);
  store.state.token = obj.token;
  localStorage.setItem('token', obj.token);
  if (obj.color && obj.color === 'black') {
    constantRouterMap = [{
      path: '/',
      redirect: '/social/club',
      name: 'index',
      component: function component() {
        return import('@/viewsBlack/index');
      },
      meta: {
        showBottomBar: false
      }
      // beforeEnter: (to, from, next) => {
      //   console.log('beforeEnter')
      //   next()
      // }
    }, {
      path: '/login',
      name: 'Login',
      component: function component() {
        return import('@/viewsBlack/login');
      },
      meta: {
        showBottomBar: false
      }
    }, {
      path: '/register',
      name: 'register',
      component: function component() {
        return import('@/viewsBlack/register');
      },
      meta: {
        showBottomBar: false
      }
    }, {
      path: '/forgetPassword',
      name: 'forgetPassword',
      component: function component() {
        return import('@/viewsBlack/forgetPassword');
      },
      meta: {
        showBottomBar: false
      }
    }, {
      path: '/selectCountry',
      name: 'selectCountry',
      component: function component() {
        return import('@/viewsBlack/selectCountry');
      },
      meta: {
        showBottomBar: false
      }
    }, {
      path: '/map',
      name: 'map',
      component: function component() {
        return import('@/viewsBlack/map/index');
      },
      meta: {
        showBottomBar: true,
        index: 5
      }
    }, {
      path: '/vehicleControl',
      name: 'VehicleControl',
      component: function component() {
        return import('@/viewsBlack/vehicleControl');
      },
      meta: {
        showBottomBar: true,
        index: 6
      }
    }, {
      path: '/message',
      name: 'message',
      component: function component() {
        return import('@/viewsBlack/message/index');
      },
      meta: {
        showBottomBar: true,
        index: 7
      }
    }, {
      path: '/message/detail',
      name: 'detail',
      component: function component() {
        return import('@/viewsBlack/message/detail');
      }
    }, {
      path: '/me',
      name: 'me',
      component: function component() {
        return import('@/viewsBlack/me/index');
      },
      meta: {
        showBottomBar: true,
        index: 8
      }
    }, {
      path: '/others',
      name: 'me',
      component: function component() {
        return import('@/viewsBlack/me/others');
      },
      meta: {
        showBottomBar: false
      }
    }, {
      path: '/me/detail',
      name: 'detail',
      component: function component() {
        return import('@/viewsBlack/me/detail');
      }
    }, {
      path: '/me/account',
      name: 'account',
      component: function component() {
        return import('@/viewsBlack/me/account');
      }
    }, {
      path: '/me/myactivity',
      name: 'myactivity',
      component: function component() {
        return import('@/viewsBlack/me/myactivity');
      }
    }, {
      path: '/vehicleManagement',
      name: 'vehicleManagement',
      component: function component() {
        return import('@/viewsBlack/vehicleManagement');
      },
      meta: {
        showBottomBar: false
      }
    }, {
      path: '/vehicleUnbund',
      name: 'vehicleUnbund',
      component: function component() {
        return import('@/viewsBlack/vehicleUnbund');
      },
      meta: {
        showBottomBar: false
      }
    }, {
      path: '/loginVerification',
      name: 'loginVerification',
      component: function component() {
        return import('@/viewsBlack/loginVerification');
      },
      meta: {
        showBottomBar: false
      }
    },
    // {
    //   path: '/',
    //   redirect: '/social/club',
    //   name: 'club',
    //   component: () => import('@/viewsBlack/social/index'),
    //   meta: {
    //     showBottomBar: true,
    //     index: 1
    //   }
    // },
    {
      path: '/social/detail',
      name: 'detail',
      component: function component() {
        return import('@/viewsBlack/social/detail');
      },
      meta: {
        showBottomBar: false
      }
    }, {
      path: '/social/share',
      name: 'share',
      component: function component() {
        return import('@/viewsBlack/social/share');
      },
      meta: {
        showBottomBar: false
      }
    }, {
      path: '/social/comment',
      name: 'comment',
      component: function component() {
        return import('@/viewsBlack/social/comment');
      },
      meta: {
        showBottomBar: false
      }
    }, {
      path: '/social/topic',
      name: 'topic',
      component: function component() {
        return import('@/viewsBlack/social/topic');
      },
      meta: {
        showBottomBar: false
      }
    }, {
      path: '/social/allTopic',
      name: 'allTopic',
      component: function component() {
        return import('@/viewsBlack/social/allTopic');
      },
      meta: {
        showBottomBar: false
      }
    }, {
      path: '/social/testDrive',
      name: 'topic',
      component: function component() {
        return import('@/viewsBlack/social/testDrive');
      },
      meta: {
        showBottomBar: false
      }
    }, {
      path: '/social/question',
      name: 'question',
      component: function component() {
        return import('@/viewsBlack/social/question');
      },
      meta: {
        showBottomBar: false
      }
    }, {
      path: '/social/questionList',
      name: 'questionList',
      component: function component() {
        return import('@/viewsBlack/social/questionList');
      },
      meta: {
        showBottomBar: false
      }
    }, {
      path: '/social/manualDetails',
      name: 'manualDetails',
      component: function component() {
        return import('@/viewsBlack/social/manualDetails');
      },
      meta: {
        showBottomBar: false
      }
    }, {
      path: '/social/manual',
      name: 'manual',
      component: function component() {
        return import('@/viewsBlack/social/manual');
      },
      meta: {
        showBottomBar: false
      }
    }, {
      path: '/social/post',
      name: 'post',
      component: function component() {
        return import('@/viewsBlack/social/post');
      },
      meta: {
        showBottomBar: false
      }
    }, {
      path: '/social/postArticle',
      name: 'postArticle',
      component: function component() {
        return import('@/viewsBlack/social/postArticle');
      },
      meta: {
        showBottomBar: false
      }
    }, {
      path: '/social/choose',
      name: 'choose',
      component: function component() {
        return import('@/viewsBlack/social/choose');
      },
      meta: {
        showBottomBar: false
      }
    }, {
      path: '/social/search',
      name: 'search',
      component: function component() {
        return import('@/viewsBlack/social/search/index');
      },
      meta: {
        showBottomBar: false
      },
      children: [{
        path: 'all',
        name: 'all',
        component: function component() {
          return import('@/viewsBlack/social/search/all');
        },
        meta: {
          showBottomBar: false,
          index: 1
        }
      }, {
        path: 'club',
        name: 'club',
        component: function component() {
          return import('@/viewsBlack/social/search/club');
        },
        meta: {
          showBottomBar: false,
          index: 2
        }
      }, {
        path: 'activity',
        name: 'activity',
        component: function component() {
          return import('@/viewsBlack/social/search/activity');
        },
        meta: {
          showBottomBar: false,
          index: 3
        }
      }, {
        path: 'video',
        name: 'video',
        component: function component() {
          return import('@/viewsBlack/social/search/video');
        },
        meta: {
          showBottomBar: false,
          index: 4
        }
      }, {
        path: 'news',
        name: 'news',
        component: function component() {
          return import('@/viewsBlack/social/search/news');
        },
        meta: {
          showBottomBar: false,
          index: 5
        }
      }, {
        path: 'user',
        name: 'user',
        component: function component() {
          return import('@/viewsBlack/social/search/user');
        },
        meta: {
          showBottomBar: false,
          index: 6
        }
      }]
    }, {
      path: '/social',
      name: 'social',
      component: function component() {
        return import('@/viewsBlack/social/index');
      },
      children: [{
        path: 'club',
        name: 'club',
        component: function component() {
          return import('@/viewsBlack/social/club/index');
        },
        meta: {
          showBottomBar: true,
          index: 1
        }
      }, {
        path: 'activity',
        name: 'activity',
        component: function component() {
          return import('@/viewsBlack/social/activity/index');
        },
        meta: {
          showBottomBar: true,
          index: 2
        }
      }, {
        path: 'video',
        name: 'video',
        component: function component() {
          return import('@/viewsBlack/social/video/index');
        },
        meta: {
          showBottomBar: true,
          index: 3
        }
      }, {
        path: 'news',
        name: 'news',
        component: function component() {
          return import('@/viewsBlack/social/news/index');
        },
        meta: {
          showBottomBar: true,
          index: 4
        }
      }, {
        path: 'Knowledge',
        name: 'Knowledge',
        component: function component() {
          return import('@/viewsBlack/social/Knowledge/index');
        },
        meta: {
          showBottomBar: true,
          index: 5
        }
      }, {
        path: 'hot',
        name: 'hot',
        component: function component() {
          return import('@/viewsBlack/social/hot/index');
        },
        meta: {
          showBottomBar: true,
          index: 5
        }
      }, {
        path: 'Q&A',
        name: 'Q&A',
        component: function component() {
          return import('@/viewsBlack/social/Q&A/index');
        },
        meta: {
          showBottomBar: true,
          index: 5
        }
      }]
    }];
  } else {
    constantRouterMap = [{
      path: '/',
      redirect: '/social/club',
      name: 'index',
      component: function component() {
        return import('@/views/index');
      },
      meta: {
        showBottomBar: false
      }
      // beforeEnter: (to, from, next) => {
      //   console.log('beforeEnter')
      //   next()
      // }
    }, {
      path: '/login',
      name: 'Login',
      component: function component() {
        return import('@/views/login');
      },
      meta: {
        showBottomBar: false
      }
    }, {
      path: '/register',
      name: 'register',
      component: function component() {
        return import('@/views/register');
      },
      meta: {
        showBottomBar: false
      }
    }, {
      path: '/forgetPassword',
      name: 'forgetPassword',
      component: function component() {
        return import('@/views/forgetPassword');
      },
      meta: {
        showBottomBar: false
      }
    }, {
      path: '/selectCountry',
      name: 'selectCountry',
      component: function component() {
        return import('@/views/selectCountry');
      },
      meta: {
        showBottomBar: false
      }
    }, {
      path: '/map',
      name: 'map',
      component: function component() {
        return import('@/views/map/index');
      },
      meta: {
        showBottomBar: true,
        index: 5
      }
    }, {
      path: '/vehicleControl',
      name: 'VehicleControl',
      component: function component() {
        return import('@/views/vehicleControl');
      },
      meta: {
        showBottomBar: true,
        index: 6
      }
    }, {
      path: '/message',
      name: 'message',
      component: function component() {
        return import('@/views/message/index');
      },
      meta: {
        showBottomBar: true,
        index: 7
      }
    }, {
      path: '/social/manualsgc',
      name: 'manualsgc',
      component: function component() {
        return import('@/views/social/manualsgc');
      },
      meta: {
        showBottomBar: false
      }
    }, {
      path: '/social/manualsdc',
      name: 'manualsdc',
      component: function component() {
        return import('@/views/social/manualsdc');
      },
      meta: {
        showBottomBar: false
      }
    }, {
      path: '/social/manualsep',
      name: 'manualsep',
      component: function component() {
        return import('@/views/social/manualsep');
      },
      meta: {
        showBottomBar: false
      }
    }, {
      path: '/social/manualsmg5',
      name: 'manualsmg5',
      component: function component() {
        return import('@/views/social/manualsmg5');
      },
      meta: {
        showBottomBar: false
      }
    }, {
      path: '/social/manualsev',
      name: 'manualsev',
      component: function component() {
        return import('@/views/social/manualsev');
      },
      meta: {
        showBottomBar: false
      }
    }, {
      path: '/social/manualsvs',
      name: 'manualsvs',
      component: function component() {
        return import('@/views/social/manualsvs');
      },
      meta: {
        showBottomBar: false
      }
    }, {
      path: '/social/manualshs',
      name: 'manualshs',
      component: function component() {
        return import('@/views/social/manualshs');
      },
      meta: {
        showBottomBar: false
      }
    }, {
      path: '/social/manual',
      name: 'manual',
      component: function component() {
        return import('@/views/social/manual');
      },
      meta: {
        showBottomBar: false
      }
    }, {
      path: '/message/detail',
      name: 'detail',
      component: function component() {
        return import('@/views/message/detail');
      }
    }, {
      path: '/me',
      name: 'me',
      component: function component() {
        return import('@/views/me/index');
      },
      meta: {
        showBottomBar: true,
        index: 8
      }
    }, {
      path: '/others',
      name: 'me',
      component: function component() {
        return import('@/views/me/others');
      },
      meta: {
        showBottomBar: false
      }
    }, {
      path: '/me/detail',
      name: 'detail',
      component: function component() {
        return import('@/views/me/detail');
      }
    }, {
      path: '/me/account',
      name: 'account',
      component: function component() {
        return import('@/views/me/account');
      }
    }, {
      path: '/me/myactivity',
      name: 'myactivity',
      component: function component() {
        return import('@/views/me/myactivity');
      }
    }, {
      path: '/vehicleManagement',
      name: 'vehicleManagement',
      component: function component() {
        return import('@/views/vehicleManagement');
      },
      meta: {
        showBottomBar: false
      }
    }, {
      path: '/vehicleUnbund',
      name: 'vehicleUnbund',
      component: function component() {
        return import('@/views/vehicleUnbund');
      },
      meta: {
        showBottomBar: false
      }
    }, {
      path: '/loginVerification',
      name: 'loginVerification',
      component: function component() {
        return import('@/views/loginVerification');
      },
      meta: {
        showBottomBar: false
      }
    },
    // {
    //   path: '/',
    //   redirect: '/social/club',
    //   name: 'club',
    //   component: () => import('@/views/social/index'),
    //   meta: {
    //     showBottomBar: true,
    //     index: 1
    //   }
    // },
    {
      path: '/social/detail',
      name: 'detail',
      component: function component() {
        return import('@/views/social/detail');
      },
      meta: {
        showBottomBar: false
      }
    }, {
      path: '/social/share',
      name: 'share',
      component: function component() {
        return import('@/views/social/share');
      },
      meta: {
        showBottomBar: false
      }
    }, {
      path: '/social/comment',
      name: 'comment',
      component: function component() {
        return import('@/views/social/comment');
      },
      meta: {
        showBottomBar: false
      }
    }, {
      path: '/social/topic',
      name: 'topic',
      component: function component() {
        return import('@/views/social/topic');
      },
      meta: {
        showBottomBar: false
      }
    }, {
      path: '/social/allTopic',
      name: 'allTopic',
      component: function component() {
        return import('@/views/social/allTopic');
      },
      meta: {
        showBottomBar: false
      }
    }, {
      path: '/social/testDrive',
      name: 'topic',
      component: function component() {
        return import('@/views/social/testDrive');
      },
      meta: {
        showBottomBar: false
      }
    }, {
      path: '/social/question',
      name: 'question',
      component: function component() {
        return import('@/views/social/question');
      },
      meta: {
        showBottomBar: false
      }
    }, {
      path: '/social/questionList',
      name: 'questionList',
      component: function component() {
        return import('@/views/social/questionList');
      },
      meta: {
        showBottomBar: false
      }
    }, {
      path: '/social/post',
      name: 'post',
      component: function component() {
        return import('@/views/social/post');
      },
      meta: {
        showBottomBar: false
      }
    }, {
      path: '/social/postArticle',
      name: 'postArticle',
      component: function component() {
        return import('@/views/social/postArticle');
      },
      meta: {
        showBottomBar: false
      }
    }, {
      path: '/social/choose',
      name: 'choose',
      component: function component() {
        return import('@/views/social/choose');
      },
      meta: {
        showBottomBar: false
      }
    }, {
      path: '/social/search',
      name: 'search',
      component: function component() {
        return import('@/views/social/search2/index');
      },
      meta: {
        showBottomBar: false
      },
      children: [{
        path: 'all',
        name: 'all',
        component: function component() {
          return import('@/views/social/search2/all');
        },
        meta: {
          showBottomBar: false,
          index: 1
        }
      }, {
        path: 'club',
        name: 'club',
        component: function component() {
          return import('@/views/social/search2/club');
        },
        meta: {
          showBottomBar: false,
          index: 2
        }
      }, {
        path: 'activity',
        name: 'activity',
        component: function component() {
          return import('@/views/social/search2/activity');
        },
        meta: {
          showBottomBar: false,
          index: 3
        }
      }, {
        path: 'video',
        name: 'video',
        component: function component() {
          return import('@/views/social/search/video');
        },
        meta: {
          showBottomBar: false,
          index: 4
        }
      }, {
        path: 'news',
        name: 'news',
        component: function component() {
          return import('@/views/social/search2/news');
        },
        meta: {
          showBottomBar: false,
          index: 5
        }
      }, {
        path: 'user',
        name: 'user',
        component: function component() {
          return import('@/views/social/search/user');
        },
        meta: {
          showBottomBar: false,
          index: 6
        }
      }]
    }, {
      path: '/social',
      name: 'social',
      component: function component() {
        return import('@/views/social/index');
      },
      children: [{
        path: 'club',
        name: 'club',
        component: function component() {
          return import('@/views/social/club/index');
        },
        meta: {
          showBottomBar: true,
          index: 1
        }
      }, {
        path: 'activity',
        name: 'activity',
        component: function component() {
          return import('@/views/social/activity/index');
        },
        meta: {
          showBottomBar: true,
          index: 2
        }
      }, {
        path: 'video',
        name: 'video',
        component: function component() {
          return import('@/views/social/video/index');
        },
        meta: {
          showBottomBar: true,
          index: 3
        }
      }, {
        path: 'news',
        name: 'news',
        component: function component() {
          return import('@/views/social/news/index');
        },
        meta: {
          showBottomBar: true,
          index: 4
        }
      }, {
        path: 'Knowledge',
        name: 'Knowledge',
        component: function component() {
          return import('@/views/social/Knowledge/index');
        },
        meta: {
          showBottomBar: true,
          index: 5
        }
      }, {
        path: 'hot',
        name: 'hot',
        component: function component() {
          return import('@/views/social/hot/index');
        },
        meta: {
          showBottomBar: true,
          index: 5
        }
      }, {
        path: 'Q&A',
        name: 'Q&A',
        component: function component() {
          return import('@/views/social/Q&A/index');
        },
        meta: {
          showBottomBar: true,
          index: 5
        }
      }]
    }];
  }
}
export { constantRouterMap };